export default function HeadingTwoIcon() {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="19.763"
      height="14.001"
      viewBox="0 0 19.763 14.001"
    >
      <g transform="translate(-632.662 -163.003)">
        <path
          fill="currentColor"
          d="M13297.5-3489.16v-6.413h-6.934v6.413h-1.887v-14h1.887v5.928h6.934v-5.928h1.888v14zm4.5 0v-1.149l3.41-3.677a2.954 2.954 0 001.045-1.9 1.307 1.307 0 00-1.393-1.306 1.344 1.344 0 00-1.4 1.379v.1h-1.75v-.09a2.9 2.9 0 013.192-2.869c1.928 0 3.187 1.129 3.187 2.612 0 1.282-.828 2.077-1.644 2.966l-2.117 2.338v.09h3.918v1.5z"
          data-name="Union 35"
          transform="translate(-12656.019 3666.164)"
        ></path>
      </g>
    </svg>
  );
}
